import { api } from "@/lib/api-client";
import type { ApiResponse } from "@/types/api";

export type NotificationType =
  | "fee_overdue"
  | "fee_payment"
  | "attendance_alert"
  | "announcement"
  | "exam_reminder"
  | "incident"
  | "leave_request"
  | "admission"
  | "system";

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  read: boolean;
  created_at: string;
  action_url?: string;
  actor_name?: string;
  meta?: Record<string, unknown>;
}

export interface NotificationCounts {
  total: number;
  unread: number;
  by_type: Partial<Record<NotificationType, number>>;
}

export const notificationsApi = {
  list: (params?: { page?: number; limit?: number; unread_only?: boolean }) =>
    api
      .get<ApiResponse<Notification[]>>("/notifications", { params })
      .then((r) => r.data),

  getCounts: () =>
    api
      .get<ApiResponse<NotificationCounts>>("/notifications/counts")
      .then((r) => r.data.data),

  markRead: (id: string) =>
    api.patch<ApiResponse<Notification>>(`/notifications/${id}/read`).then((r) => r.data.data),

  markAllRead: () =>
    api.patch<ApiResponse<{ updated: number }>>("/notifications/read-all").then((r) => r.data.data),

  delete: (id: string) =>
    api.delete(`/notifications/${id}`),
};
